import { connect } from 'react-redux';
import { withRouter } from 'react-router';

import ShowAgreement from './ShowAgreement';

const mapStateToProps = state => ({
  merchants: state.merchants,
});

// Provide the location as prop, in order to bust the should component render cache
export default withRouter(connect(mapStateToProps, null)(ShowAgreement));
